
import { Box, Grid, Stack, Typography } from "@mui/material";
import { labelSx, sectionTitleSx, valueSx, formatDate } from "./styles";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ProceduresSection = ({ procedures = [] }: { procedures?: any[] }) => (
    <Box
        sx={{
            bgcolor: "linear-gradient(135deg, #f8f9fa 0%, #f0fffe 100%)",
            p: 3,
            borderRadius: 3,
            border: "2px solid #f0f0f0",
            boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
            position: "relative",
            "&::before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: "5px",
                background: "linear-gradient(180deg, #2fbf71 0%, #27a864 100%)",
                borderRadius: "3px 0 0 3px"
            }
        }}
    >
        <Typography sx={{ ...sectionTitleSx, ml: 1 }}>Procedures</Typography>
        {procedures.length === 0 ? (
            <Typography sx={labelSx}>No procedures recorded.</Typography>
        ) : (
            <Stack spacing={1.5}>
                {procedures.map((proc, idx) => (
                    <Box
                        key={`procedure-${idx}`}
                        sx={{
                            p: 2,
                            border: "2px solid #f0f0f0",
                            borderRadius: 2.5,
                            bgcolor: "linear-gradient(135deg, #fafafa 0%, #f5fffe 100%)",
                            boxShadow: "0 4px 16px rgba(129,196,187,0.12)",
                            transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                                boxShadow: "0 8px 24px rgba(129,196,187,0.2)",
                                borderColor: "#2fbf71",
                                bgcolor: "#fff",
                                transform: "translateY(-2px)"
                            }
                        }}
                    >
                        <Typography sx={valueSx}>{proc.procedureText || "Procedure"}</Typography>
                        <Grid
                            container
                            spacing={2}
                            sx={{
                                mt: 0.5,
                                display: "grid",
                                gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" }
                            }}
                        >
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <Typography sx={labelSx}>Status</Typography>
                                <Typography sx={valueSx}>{proc.status || "—"}</Typography>
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                <Typography sx={labelSx}>Performed Date</Typography>
                                <Typography sx={valueSx}>{formatDate(proc.performedDate)}</Typography>
                            </Box>
                        </Grid>
                    </Box>
                ))}
            </Stack>
        )}
    </Box>
);

export default ProceduresSection;
